import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import { Image, Col, Row, Button, NavItem } from 'react-bootstrap'
import TextTruncate from 'react-text-truncate'
import { getUrlParams, redirectWithConfirm, saveUrlParams } from '../common/utils.js'
import get from 'lodash/get'
import FontAwesome from 'react-fontawesome'
import { Style } from 'radium'

class PostList extends React.Component {
  componentDidMount() {
    saveUrlParams()
  }

  showModal = () => {
    if (window) {
      this.props.showShareModal(window.location.href + `post?id=${this.props.post.id}&utm_source=viewspark&utm_medium=share`,
        this.props.post.title, this.props.config.stringValues.site.title + "\n" + this.props.post.title)
    }
  }

  renderGiveButton = () => {
    const giveButtonLabel = get(this.props.post, 'giveButtonLabel', get(this.props.config.stringValues, 'site.buttons.newsFeed', 'Give Now'))
    const externalUrl = get(this.props.post, 'giveButtonUrl', get(this.props.config, 'customDonationUrl', undefined))
    const giveInstructions = get(this.props.config, 'giveInstructions', undefined)
    const enableInstructionsPopUp = get(this.props.config, 'enableInstructionsPopUp', undefined)
    const giveNowLink = '/donate' + getUrlParams()
    if (!externalUrl) {
      return <LinkContainer to={giveNowLink} activeClassName="">
        <Button className={'give-now-button'}>
          {giveButtonLabel}
        </Button>
      </LinkContainer>
    }

    if (giveInstructions && enableInstructionsPopUp) {
      return (<Button onClick={() => {
        redirectWithConfirm(externalUrl, giveInstructions)
      }} className={'give-now-button'}>
        {giveButtonLabel}
      </Button>)
    }

    return (<Button href={externalUrl} className={'give-now-button'}>
      {giveButtonLabel}
    </Button>)
  }

  render() {
    let imageContent = null

    if (this.props.isNewsFeed) {
      let media = this.props.post.media
      let mediaKey = Object.keys(media)[0]
      let mediaThumbnail = null
      let imgResponsive = ''
      if (media[mediaKey]['type'] === 'image') {
        imgResponsive = 'img-responsive'
      } else {
        mediaKey = Object.keys(media)[1]
      }
      let gifThumbnail = this.props.config.enableGifPreview ? media[mediaKey]['gifThumbnailUrl'] : null
      mediaThumbnail = gifThumbnail ? gifThumbnail : media[mediaKey]['mmsImageUrl'] ? media[mediaKey]['mmsImageUrl'] : media[mediaKey]['mediaUrl']

      imageContent = <Row className='center-block'>
        <div className='image'>
          <Link to={`/post${getUrlParams()}&id=${this.props.post.id}`}>
            <Image className={imgResponsive} src={mediaThumbnail} />
          </Link>
        </div>
      </Row>
    }
    const borderRadiusStyle = get(this.props.config.stringValues, 'site.buttons.borderRadius', '9px')

    const options = { month: 'short', weekday: 'short', day: 'numeric', year: 'numeric' }
    return (
      <Col xs={12} md={6} lg={4} className='post-list'>
        <Style
          scopeSelector='.post-list'
          rules={{
            '.actions .give-now-button': {
              borderRadius: borderRadiusStyle
            }
          }}
        />
        {imageContent}
        <Row className='center-block'>
          <div className='content'>
            <div className='post-header'>
              <div className='title'>
                <Link to={`/post?id=${this.props.post.id}`}>
                  <TextTruncate line={2} truncateText='…' text={this.props.post.title} />
                </Link>
              </div>
              <div className='date'>{new Date(-(this.props.post.publishedOn)).toLocaleDateString('en-US', options)}</div>
            </div>
            <div className='description'>
              <TextTruncate line={3} truncateText='…'
                text={this.props.post.content} textTruncateChild={<Link to={`/post?id=${this.props.post.id}`}>Read More</Link>} />
            </div>
            <div className='actions'>
              <div className={'share'} onClick={this.showModal}>
                <FontAwesome name={'share-alt'} size={'1.5x'} />
                <span>  Share</span>
              </div>
              {!this.props.config.disableGive && this.renderGiveButton()}
              <a className='clear' />
            </div>
          </div>
        </Row>
      </Col>
    )
  }
}

const mapStateToProps = (state) => ({
  config: state.config
})


export default connect(
  mapStateToProps
)(PostList)
